import HelpAccordion from "features/help/components/HelpAccordion/HelpAccordion";
import InputMobile from "common/components/InputMobile";
import MainPageHeaderMobile from "common/components/MainPageHeader/MainPageHeaderMobile";
import React from "react";
import CardIcon from "assets/icons/help/card-help-mobile.png";

interface Props {
  onChangeText?: (val: string) => void;
  searchText?: string;
  serachData?: any;
  dataHelp?: any;
}

const HelpMobile = ({ onChangeText, searchText, serachData, dataHelp }: Props) => {
  return (
    <div className="help-wrapper-mobile">
      <MainPageHeaderMobile title="עזרה" />
      <div className="input-container-pink-bg">
        <InputMobile onChangeText={onChangeText} isSearch />
      </div>
      <div className="help-content-mobile">
        <HelpAccordion data={searchText ? serachData : dataHelp} />
      </div>
      <div className="footer-help">
        <img src={CardIcon} />
      </div>
    </div>
  );
};

export default HelpMobile;
